import UIComponent from './uiComponent';
export default class UIValue extends UIComponent {
    value;
    error;
    constructor(s) {
        super(s);
        this.value = '';
        this.error = undefined;
    }
    getComponent() {
        return null;
    }
}
//# sourceMappingURL=uiValue.js.map